import { FormattedMessage } from 'react-intl';

import CheckCircle from '@mui/icons-material/CheckCircle';
import { Stack, StackProps, Typography } from '@mui/material';

export const AccreditedOfferingBadge = (props: StackProps) => {
  return (
    <Stack direction="row" alignItems="center" gap={0.5} {...props}>
      <CheckCircle sx={{ color: 'primary', width: '20px', height: '20px' }} />
      <Typography>
        <FormattedMessage id="accredited-only-offering" defaultMessage="Accredited Only Offering" />
      </Typography>
    </Stack>
  );
};
